interface TextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
  error?: string;
}

export default function TextField({
  label,
  value,
  onChange,
  required = false,
  placeholder,
  error,
}: TextFieldProps) {
  return (
    <div>
      <label className="block text-xs text-gray-400 mb-1.5">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`w-full bg-[#1a1f3a] border rounded-lg px-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-orange-500/50 ${
          error ? 'border-red-500/50' : 'border-[#2d1b3d]'
        }`}
      />
      {error && <div className="text-xs text-red-400 mt-1">{error}</div>}
    </div>
  );
}



